import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotification } from './components/PurchaseNotification';
import { NewTopBar } from './components/NewTopBar';
import { NewHero } from './components/NewHero';
import { NewProblem } from './components/NewProblem';
import { NewTransformation } from './components/NewTransformation';
import { NewHowItWorks } from './components/NewHowItWorks';
import { NewProductReveal } from './components/NewProductReveal';
import { NewTomos } from './components/NewTomos';
import { NewComparison } from './components/NewComparison';
import { NewAuthority } from './components/NewAuthority';
import { NewMidCTA } from './components/NewMidCTA';
import { NewBonos } from './components/NewBonos';
import { NewTestimonials } from './components/NewTestimonials';
import { NewGuarantee } from './components/NewGuarantee';
import { NewOffers } from './components/NewOffers';
import { NewFinalClose } from './components/NewFinalClose';
import { NewUrgency } from './components/NewUrgency';
import { NewFooter } from './components/NewFooter';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-charcoal selection:bg-sage/30 selection:text-forest flex flex-col" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <PurchaseNotification data-id="element-2" />

      <NewTopBar data-id="element-3" />

      <main className="flex-grow" data-id="element-4">
        <NewHero data-id="element-5" />
        <NewProblem data-id="element-6" />
        <NewTransformation data-id="element-7" />
        <NewHowItWorks data-id="element-8" />
        <NewProductReveal data-id="element-9" />
        <NewTomos data-id="element-10" />
        <NewComparison data-id="element-11" />
        <NewAuthority data-id="element-12" />
        <NewMidCTA data-id="element-13" />
        <NewBonos data-id="element-14" />
        <NewTestimonials data-id="element-15" />
        <NewGuarantee data-id="element-16" />
        <NewOffers data-id="element-17" />
        <NewFinalClose data-id="element-18" />
        <NewUrgency data-id="element-19" />
      </main>

      <NewFooter data-id="element-20" />
    </div>;
}